import LinkTracker from '../lib/LinkTracker';
import { CustomUrlTracker } from '../lib/CustomUrlTracker';
import { trackingConfig as trackingSL } from './tracking.config';

new LinkTracker();
const customUrlTracker = new CustomUrlTracker();

// TODO: I would like to move this to planner-question.js but it'll constantly conflict due to branch management. Will fix when planner is done.
$('.planner-question-review-options input').on(
    'change',
    function trackPlannerQuestion() {
        const dataLayer = (window.dataLayer = window.dataLayer || []);
        const id =
            parseInt(/answers\[(.*)]/g.exec($(this).attr('name'))[1], 10) + 1;

        dataLayer.push({
            event: 'gp-interaction',
            category: 'Planner 2017',
            action: 'Change answer',
            label: `answers ${id}`,
            'interaction-type': true,
        });
    }
);

$('a[href$=".pdf"]').on('click', function trackPdfView() {
    const filename = $(this).attr('href').split('/').reverse()[0];
    customUrlTracker.fileView({
        filename,
        filetype: 'PDF',
    });
});

if (trackingSL.SKIP_LINKS === true) {
    const dataLayer = (window.dataLayer = window.dataLayer || []);
    const $skipLinks = $('.skip-links li a');
    $skipLinks.on('click', function clickLink() {
        const text = $(this).text();
        dataLayer.push({
            event: 'gp-interaction',
            category: 'Skip Link',
            action: 'Click',
            label: text,
            'interaction-type': true,
        });
    });
}
